/// <reference types="@types/googlemaps" />
import { Inject, Injectable } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { EnvService } from './env.service';
import { Observable, Observer } from 'rxjs';
@Injectable({
  providedIn: 'root',
})
export class MapService {
  geocoder!: google.maps.Geocoder;

  constructor(
    private environment: EnvService,
    @Inject(DOCUMENT) private document: any
  ) {}

  public loadMap(callback: any): void {
    if (!this.document.getElementById('map') && !window['google']) {
      const gmapScript = this.document.createElement('script');
      const url = `https://maps.googleapis.com/maps/api/js?key=${this.environment.gmapKey}&language=${this.environment.language}&libraries=places&callback=onGmapApiLoaded`;

      gmapScript.setAttribute('type', 'text/javascript');
      gmapScript.setAttribute('id', 'map');
      gmapScript.setAttribute('src', url);

      this.document.body.appendChild(gmapScript);
      window['onGmapApiLoaded'] = () => callback();
    } else {
      callback();
    }
  }

  public geoCodePosition(pos: any, google: any): Observable<string> {
    return Observable.create((observer: Observer<string>) => {
      this.geocoder = new google.maps.Geocoder();
      if (!!this.geocoder.geocode) {
        this.geocoder.geocode(
          {
            location: pos,
          },
          (results, status: any) => {
            if (status === 'OK' && results[0]) {
              observer.next(results[0].formatted_address);
              observer.complete();
            } else {
              observer.next('null');
              observer.complete();
            }
          }
        );
      } else {
        observer.next('null');
        observer.complete();
      }
    });
  }
}
